
import Menu from '@/components/menu/menu.vue'
import { ElForm } from 'element-ui/types/form'
import { getHotelList } from '@/api/hotel'
import { adminToken } from '@/libs/local-store'
import { getbill, postInvoiceUpload, getInvoiceiew } from '@/api/ota'
import { getOssUrl, getUploadFileUrl } from '@/api/common'
import Vue from 'vue'
import axios from 'axios'
export default Vue.extend({
	components: {
		Menu,
	},
	data() {
		return {
			uploadDia: false,
			hotels: [] as any, // 酒店选项
			status: [
				// 发票状态 空-全部 1-已开票 2-未开票
				{
					id: '',
					name: '全部',
				},
				{
					id: 1,
					name: '已开票',
				},
				{
					id: 2,
					name: '待开票',
				},
			],
			searchForm: {
				hotel_id: '',
				invoice: 2 as any,
			},

			editHotelDialog: false,
			hotel_submit_form_title: '',
			room_type_form: {
				id: undefined as string | undefined,
				sale_type: '',
				pms_room_code: '',
				sale_room_name: '',
				sale_room_code: '',
				sale_info: [
					{
						sale_room_name: '',
						sale_room_code: '',
						sale_type: '',
					},
				],
			},
			room_type_form_rules: {
				pms_room_code: [{ required: true, message: '请输入PMS房型名称', trigger: 'change' }],
				sale_room_name: [{ required: true, message: '请输入房型名称（产品）', trigger: 'blur' }],
				sale_type: [{ required: true, message: '请选择售卖类型', trigger: ['change', 'blur'] }],
				uploadImg: [{ required: true, message: '请上传发票', trigger: ['change', 'blur'] }],
			},
			editRoomDialog: false,
			room_type_form_title: '',
			orderStauts: '1',
			table_data: [],
			table_state: {
				loading: false,
			},
			src_channel: '美团',
			old_ding_secret: '',
			old_ding_webhook: '',
			uploadinvoiceForm: {
				id: '',
				invoice: '',
				fileList: [] as any,
			},
			baseUrl: '',
			TOKEN: '',
			total: 0,
			limit: 10,
			page: 1,
			totalAmount: 0,
		}
	},
	computed: {
		returnFont() {
			if (this.searchForm.invoice == '') {
				return '全部开票'
			}
			if (this.searchForm.invoice == 1) {
				return '已开票'
			}
			if (this.searchForm.invoice == 2) {
				return '待开票'
			}

			return ''
		},
		getUploadFileUrl() {
			return function (id) {
				return postInvoiceUpload() + `?id=${id}`
			}
		},
		topMenuList() {
			const param = [
				{
					name: '美团订单',
					value: '3',
					info: '美团',
					disabled: false,
					id: '2',
				},
				{
					name: '马蜂窝订单',
					value: '2',
					info: '马蜂窝',
					disabled: true,
					id: '4',
				},
				{
					name: '同城订单',
					value: '待定',
					info: '马蜂窝',
					disabled: true,
					id: '3',
				},
				{
					name: '飞猪订单',
					value: '4',
					info: '飞猪',
					disabled: true,
					id: '5',
				},
				{
					name: '驴妈妈订单',
					value: '驴妈妈',
					info: '5',
					disabled: true,
					id: '6',
				},
				{
					name: '途牛订单',
					value: '6',
					info: '途牛',
					disabled: true,
					id: '7',
				},
			]
			if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
				return param
			} else {
				return param.slice(0, 1)
			}
		},
	},
	created() {
		getHotelList().then((res) => {
			if (res.code == 0) {
				// 超级管理员/ota管理员有全部权限
				if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
					this.hotels = [{ id: 0, name: '全部' }].concat(res.data.rows)
				} else {
					this.hotels = res.data.rows
				}
				this.getTableList()
			}
		})
		getOssUrl().then((res) => {
			this.baseUrl = res.data.domain.slice(0, -1)
		})
		this.TOKEN = adminToken.get()
	},
	methods: {
		getTableList() {
			getbill({
				...this.searchForm,
				src_channel: this.src_channel,
				page: this.page,
				limit: this.limit,
			}).then((res) => {
				if (res.code == 0) {
					console.log(res)
					this.table_data = res.data.map((item) => {
						let { hotel_id } = item
						let hotel = this.hotels.find((item2) => {
							return item2.id == hotel_id
						})
						return {
							...item,
							hotel_name: hotel ? hotel.name : '',
							pms_hotel_code: hotel ? hotel.miccode : '',
							complex: hotel ? hotel.complex : '',
						}
					})
					this.total = res.count
					this.totalAmount = (res as any).totalAmount || 0
				}
			})
		},
		changeLimit(data) {
			this.page = 1
			this.limit = data
			this.getTableList()
		},
		changePages(data) {
			this.page = data
			this.getTableList()
		},
		// 切换 订单类型
		changeChannelTab(data) {
			this.src_channel = data.info
		},
		search(e) {
			this.getTableList()
		},
		// 账单明细
		hotelEdit(row) {
			this.$router.push({
				name: 'invoice-account-detail',
				query: {
					billcode: row.bill_code,
					editstatus: '2',
					pms_hotel_code: row.pms_hotel_code,
					complex: row.complex,
					settlement_date: row.settlement_date,
					hotelname: row.hotel_name,
				},
			})
		},
		// 上传发票
		hotelDelete(row) {
			console.log(row)
			this.uploadinvoiceForm.id = row.id
			this.uploadinvoiceForm.fileList = []
			// this.uploadinvoiceForm.invoice = row.invoice
			// if (row.invoice) {
			// 	this.uploadinvoiceForm.fileList = [
			// 		{
			// 			name: row.invoice,
			// 			url: row.invoice,
			// 		},
			// 	]
			// }

			this.uploadDia = true
		},

		// 关闭dia重置表单
		closeHotelDialog() {
			;(this.$refs['hotel_form'] as ElForm).clearValidate()
		},
		closeRoomDialog() {
			this.room_type_form = {
				id: '',
				sale_type: '',
				pms_room_code: '',
				sale_room_name: '',
				sale_room_code: '',
				sale_info: [
					{
						sale_room_name: '',
						sale_room_code: '',
						sale_type: '',
					},
				],
			}
			;(this.$refs['room_form'] as ElForm).clearValidate()
		},

		submitForm(formName: string) {
			;(this.$refs[formName] as ElForm).validate((valid) => {
				if (valid) {
					console.log(11)
				} else {
					return false
				}
			})
		},

		invoiceExport(row) {
			let baseurl = getInvoiceiew() + `?id=${row.id}`
			console.log(row)
			this.downloadFileWithHeaders(baseurl, row.hotel_name + row.settlement_date + '发票')
		},
		async downloadFileWithHeaders(url, filename) {
			try {
				const response = await fetch(url, {
					headers: {
						token: this.TOKEN, // 添加自定义 Header
					},
				})

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`)
				}

				const blob = await response.blob()
				const downloadUrl = URL.createObjectURL(blob)

				// 创建隐藏的 <a> 标签触发下载
				const a = document.createElement('a')
				a.href = downloadUrl
				a.download = filename || 'downloaded-file' // 设置下载文件名
				document.body.appendChild(a)
				a.click()

				// 清理
				setTimeout(() => {
					document.body.removeChild(a)
					URL.revokeObjectURL(downloadUrl)
				}, 100)
			} catch (error) {
				console.error('Download failed:', error)
			}
		},
		beforeAvatarUpload(file) {
			let type = file.type
			let arr = type.split('/')
			let state = false
			state = arr.indexOf('pdf') !== -1
			if (!state) {
				this.$message.error('图片上传格式错误，请重试')
			}
			return state
		},
		showFile(event) {
			console.log(event)
			window.open(event.path)
		},
		handleAvatarSuccess(res, file) {
			console.log(file)
			if (res.code == 0) {
				this.$message({
					type: 'success',
					message: res.msg,
				})
				this.getTableList()
			}
			this.uploadDia = false
		},
		removeFIle() {
			this.uploadinvoiceForm.invoice = ''
		},
	},
})
